import Vue from 'vue'
import consts from '@/consts'
import { createActionHelpers } from 'vuex-loading'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

const ALLOW_ADAPTATION = 0
const NOT_ALLOW_ADAPTATION = 1
const ALLOW_WITHOUT_MODIFICATIONS = 2
const ALLOW_COMMERCIAL_USES = 0
const NOT_ALLOW_COMMERCIAL_USES = 1

const initialStates = function () {
  return {
    licenses: [],
    actualLicense: Object,
    adaptationCondition: 1,
    commercialCondition: 1
  }
}

const mutations = {
  getLicenses (state, value) {
    state.licenses = value
  },
  setActualLicense (state) {
    // set actual license from adaptationCondition and commercialCondition values
    if (state.adaptationCondition === ALLOW_ADAPTATION && state.commercialCondition === ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[0]
    }
    if (state.adaptationCondition === ALLOW_ADAPTATION && state.commercialCondition === NOT_ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[3]
    }
    if (state.adaptationCondition === NOT_ALLOW_ADAPTATION && state.commercialCondition === ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[2]
    }
    if (state.adaptationCondition === NOT_ALLOW_ADAPTATION && state.commercialCondition === NOT_ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[5]
    }
    if (state.adaptationCondition === ALLOW_WITHOUT_MODIFICATIONS && state.commercialCondition === ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[1]
    }
    if (state.adaptationCondition === ALLOW_WITHOUT_MODIFICATIONS && state.commercialCondition === NOT_ALLOW_COMMERCIAL_USES) {
      state.actualLicense = state.licenses[4]
    }
  },
  setLicenseValues (state, id) {
    // set adaptationCondition and license 2 from license id
    switch (id) {
      case state.licenses[0]: {
        state.adaptationCondition = ALLOW_ADAPTATION
        state.commercialCondition = ALLOW_COMMERCIAL_USES
        break
      }
      case state.licenses[1]: {
        state.adaptationCondition = ALLOW_WITHOUT_MODIFICATIONS
        state.commercialCondition = ALLOW_COMMERCIAL_USES
        break
      }
      case state.licenses[2]: {
        state.adaptationCondition = NOT_ALLOW_ADAPTATION
        state.commercialCondition = ALLOW_COMMERCIAL_USES
        break
      }
      case state.licenses[3]: {
        state.adaptationCondition = ALLOW_ADAPTATION
        state.commercialCondition = NOT_ALLOW_COMMERCIAL_USES
        break
      }
      case state.licenses[4]: {
        state.adaptationCondition = ALLOW_WITHOUT_MODIFICATIONS
        state.commercialCondition = NOT_ALLOW_COMMERCIAL_USES
        break
      }
      case state.licenses[5]: {
        state.adaptationCondition = NOT_ALLOW_ADAPTATION
        state.commercialCondition = NOT_ALLOW_COMMERCIAL_USES
        break
      }
    }
  },
  setAdaptationCondition (state, value) {
    state.adaptationCondition = value
  },
  setCommercialCondition (state, value) {
    state.commercialCondition = value
  },
  resetLicense (state) {
    state.adaptationCondition = ALLOW_ADAPTATION
    state.commercialCondition = ALLOW_COMMERCIAL_USES
    state.actualLicense = state.licenses[0]
  }
}

const actions = {
  getLicenses ({ commit, dispatch }) {
    startLoading(dispatch, 'license getLicenses')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/tracks/getLisenses').then(
        function (response) {
          endLoading(dispatch, 'license getLicenses')
          if (response.body.status === 'ok') {
            commit('getLicenses', response.body.data)
            resolve()
          }
        },
        function () {
          endLoading(dispatch, 'license getLicenses')
          reject(new Error('Error de red'))
        })
    })
  },
  setActualLicense ({ commit }) {
    commit('setActualLicense')
  },
  setLicenseValues ({ commit }) {
    commit('setLicenseValues')
  },
  setAdaptationCondition ({ commit }, value) {
    commit('setAdaptationCondition', value)
  },
  setCommercialCondition ({ commit }, value) {
    commit('setCommercialCondition', value)
  },
  resetLicense ({ commit }) {
    commit('resetLicense')
  }
}

const getters = {
  licenses: state => {
    return state.licenses
  },
  adaptationCondition: state => {
    return state.adaptationCondition
  },
  commercialCondition: state => {
    return state.commercialCondition
  },
  actualLicense: state => {
    return state.actualLicense
  }
}

const license = {
  namespaced: true,
  initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
}

export default license



// WEBPACK FOOTER //
// ./src/store/modules/license.js